import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FormlyModule } from '@ngx-formly/core';
import { FormButtonsModule } from 'components/form-buttons/form-buttons.module';

import { FormIdPrefixModule } from 'common/form-id-prefix/form-id-prefix.module';

import { DynamicFormComponent } from './dynamic-form.component';
import { ISPValidator } from './model';
import { ISP_VALIDATORS } from './services/validators';
import { DynamicFormTemplateDirective } from './types/template/template.directive';

/**
 * Fields list module
 *
 * Usage:
 * ```html
 * <isp-field-list [fieldList]="fieldList$ | async"></isp-field-list>
 * ```
 */
@NgModule({
  declarations: [DynamicFormComponent, DynamicFormTemplateDirective],
  exports: [DynamicFormComponent, DynamicFormTemplateDirective],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormButtonsModule,
    FormIdPrefixModule,
    FormlyModule.forRoot({
      validators: [
        {
          name: ISPValidator.PassMatch,
          validation: ISP_VALIDATORS[ISPValidator.PassMatch],
        },
        {
          name: ISPValidator.Duplicate,
          validation: ISP_VALIDATORS[ISPValidator.Duplicate],
        },
        {
          name: ISPValidator.FileMaxSize,
          validation: ISP_VALIDATORS[ISPValidator.FileMaxSize],
        },
        {
          name: ISPValidator.ErrorFromBackend,
          validation: ISP_VALIDATORS[ISPValidator.ErrorFromBackend],
        },
        {
          name: ISPValidator.Required,
          validation: ISP_VALIDATORS[ISPValidator.Required],
        },
      ],
    }),
  ],
})
export class DynamicFormModule {}
